import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/core/authentication/authentication.service';
import { BillingsService } from 'app/core/services/billings.service';
import { XenditService } from 'app/core/services/xendit.service';
import { Account } from 'app/shared/models/account';
import { ToastrService } from 'ngx-toastr';
import { finalize, switchMap } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

interface Plan {
  Value: string;
  pay_plan_price: number;
  pay_plan_ID: number;
}

@Component({
  selector: 'modal-plan-renew',
  templateUrl: './modal-plan-renew.component.html',
  styleUrls: ['./modal-plan-renew.component.scss']
})
export class ModalPlanRenewComponent implements OnInit {

  isLoading: boolean = false;
  eventData: any;
  plans: Plan[] = [];
  id: any;
  planId: any;

  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private xenditService: XenditService,
    private billingService: BillingsService,
    private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.loadPlans();
  }

  loadPlans() {
    this.authService.getPlans().subscribe({
      next: res => {
        this.plans = res.filter(p => p.pay_plan_ID === this.planId);
      },
      error: err => {
        console.log(err);
      }
    })
  }

  renewPlan(planID: number): void {
    this.isLoading = true;

    this.billingService.create_bill_payment(planID).pipe(
      switchMap(() => this.authService.getAccount()),
      finalize(() => this.isLoading = false)
    ).subscribe({
      next: accountResponse => {
        localStorage.setItem('account', JSON.stringify(accountResponse));
        window.location.reload();
      },
      error: err => {
        console.error('Plan renewal failed:', err);
        this.showNotification("❌ An unexpected error occurred while renewing the plan.");
      }
    });
  }

  renewPlanXendit(price: number, planID: number) {
    this.isLoading = true;
    const storedAccount = localStorage.getItem('account');
    const account: Account = JSON.parse(storedAccount);

    const domain = window.location.origin;
    const success_url = `${domain}/#/plan-renew`;
    const failUrl = `${domain}/#/plan-renew`;
    const fee = 0;

    this.xenditService.xenditPay(price, this.id, planID, success_url, failUrl, account.email, account.name).subscribe({
      next: res => {
        this.isLoading = false;
        const invoiceUrl = res.checkoutUrl;
        window.location.href = invoiceUrl;
      },
      error: err => {
        this.showNotification("Failed to create Xendit: API key is missing");
      }
    });
  }

  save() {
    this.isLoading = true;
  }

  showNotification(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-danger alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }
}

